declare global {
    interface Window {
        dataLayer:any;
    }
}

export const SendGoogleEvent = (
    eventName:string
  ) => {
    console.log("Firing event "+eventName);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': eventName });
  };
  